import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ErrorHandler,
  withTranslation,
} from '@playbookux/playbook-web-core';
import {
  Wrapper, Header, Body, Title, Description, FormsContainer, Link,
  FormLine, InputContainer, SubmitContainer, SubmitButton, InputLine,
  RadioInput, InputLabel, InputLabelBold, ConsentLink,
} from './styles';
import { NDA_LINK, TERMS_AND_SERVICES_LINK } from './constants';

const ConsentFormPrompt = ({ consentForms, onSubmitAnswer, phrases }) => {
  const [acceptsConsentForms, setAcceptsConsentForms] = useState();

  const handleSelection = (accepts) => {
    setAcceptsConsentForms(accepts);
  };

  const handleSubmit = () => {
    if (typeof (acceptsConsentForms) !== 'undefined') {
      onSubmitAnswer(acceptsConsentForms);
    }
  };

  return (
    <Wrapper>
      <Header>
        <Title>
          {phrases.consent_screener_title}
        </Title>
        <Description>
          {phrases.consent_screener_review}
          {' '}
          <Link target="_blank" href={NDA_LINK}>{phrases.consent_screener_review_2}</Link>
          {' '}
          {phrases.consent_screener_review_3}
          {' '}
          <Link target="_blank" href={TERMS_AND_SERVICES_LINK}>{phrases.consent_screener_review_4}</Link>
          .
        </Description>
      </Header>
      <Body>
        <FormsContainer>
          {
            consentForms.map(({ id, filePath }) => (
              <FormLine key={id}>
                <ConsentLink target="_blank" href={filePath}>
                  {phrases.consent_screener_view}
                </ConsentLink>
              </FormLine>
            ))
          }
        </FormsContainer>
        <InputContainer>
          <InputLine onClick={() => handleSelection(true)}>
            <RadioInput checked={acceptsConsentForms} />
            <InputLabel>
              <InputLabelBold>{phrases.consent_screener_accept}</InputLabelBold>
              {' '}
              {phrases.consent_screener_accept_2}
            </InputLabel>
          </InputLine>

          <InputLine marginTop="5px" onClick={() => handleSelection(false)}>
            <RadioInput
              checked={
                typeof acceptsConsentForms !== 'undefined'
                && !acceptsConsentForms
              }
            />
            <InputLabel>
              <InputLabelBold>{phrases.consent_screener_decline}</InputLabelBold>
              {' '}
              {phrases.consent_screener_decline_2}
            </InputLabel>
          </InputLine>

          <InputLine marginTop="5px">
            {
              typeof (acceptsConsentForms) === 'undefined'
              && (
                <ErrorHandler
                  error={{ message: 'Please select an option to continue.' }}
                  defaultMessage=""
                />
              )
            }
          </InputLine>
        </InputContainer>
        <SubmitContainer>
          <SubmitButton onClick={handleSubmit}>
            {phrases.consent_screener_submit}
          </SubmitButton>
        </SubmitContainer>
      </Body>
    </Wrapper>
  );
};

ConsentFormPrompt.propTypes = {
  consentForms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    fileUrl: PropTypes.string,
  })),
  onSubmitAnswer: PropTypes.func.isRequired,
  phrases: PropTypes.shape({
    consent_screener_title: PropTypes.string,
    consent_screener_view: PropTypes.string,
    consent_screener_submit: PropTypes.string,
    consent_screener_review: PropTypes.string,
    consent_screener_review_2: PropTypes.string,
    consent_screener_review_3: PropTypes.string,
    consent_screener_review_4: PropTypes.string,
    consent_screener_accept: PropTypes.string,
    consent_screener_accept_2: PropTypes.string,
    consent_screener_decline: PropTypes.string,
    consent_screener_decline_2: PropTypes.string,
  }).isRequired,
};

ConsentFormPrompt.defaultProps = {
  consentForms: [],
};

export default withTranslation(ConsentFormPrompt);
